import ParagraphComponent from "../components/paragraph";
import {RenderPosition, render} from "../utils/render";

export default class NotInStokeController {
  render(container) {
    const text = new ParagraphComponent({
      className: `product-list__itemNotAvailable`,
      text: `Нет в наличии`
    });

    render(container, text.getElement(), RenderPosition.BEFOREEND);
  }
}

// сделать кнопкой и добавить вызов окна напоминалки
